export default __webpack_public_path__ + "static/media/Youtube.60a4a4fd.png";